import { authApi } from '@/api'

export default {
  namespaced: true,

  state: {
    userId: null,
    username: null,
    roles: []
  },

  getters: {
    userId: state => state.userId,
    username: state => state.username,
    isUser: state => state.roles.some(role => role.authority === 'ROLE_USER'),
    isCurator: state => state.roles.some(role => role.authority === 'ROLE_CURATOR'),
    isAdmin: state => state.roles.some(role => role.authority === 'ROLE_ADMIN'),
    allUserRoles: state => state.roles.map(role => role.authority),
  },

  mutations: {
    setUserParams(state, payload) {
      state.userId = payload.id
      state.username = payload.username
      state.roles = payload.authorities
    },

    clearUserParams(state) {
      state.userId = null
      state.username = null
      state.roles = []
    }
  },

  actions: {
    async login({ commit }, payload) {
      const formData = new FormData();
      formData.append('username', payload.username)
      formData.append('password', payload.password)

      const data = await authApi.login(formData)
      commit('setUserParams', data)
      return data
    },

    async getCurrent({ state, commit }) {
      if (!(state.userId && state.username && state.roles.length)) {
        const data = await authApi.getCurrent()
        commit('setUserParams', data)
      }
    },

    async logout({ commit }) {
      await authApi.logout()
      commit('clearUserParams')
    }
  }
}
